import { gql } from "@apollo/client";
import { AMBASSADOR_CERTIFICATE_FIELDS } from "../queries/ambassadorCertificates";

export const CREATE_AMBASSADOR_CERTIFICATE = gql`
  mutation CreateAmbassadorCertificate(
    $input: UpdateAmbassadorCertificateInput!
  ) {
    createCertAmbassadorCertificate(input: $input) {
      ...AmbassadorCertificateFields
    }
  }
  ${AMBASSADOR_CERTIFICATE_FIELDS}
`;

export const UPDATE_AMBASSADOR_CERTIFICATE = gql`
  mutation UpdateAmbassadorCertificate(
    $id: ID!
    $input: UpdateAmbassadorCertificateInput!
  ) {
    updateCertAmbassadorCertificate(id: $id, input: $input) {
      ...AmbassadorCertificateFields
    }
  }
  ${AMBASSADOR_CERTIFICATE_FIELDS}
`;

export const DELETE_AMBASSADOR_CERTIFICATE = gql`
  mutation DeleteAmbassadorCertificate($id: ID!) {
    deleteCertAmbassadorCertificate(id: $id) {
      id
    }
  }
`;
